// src/Pages/ProjectDetails.jsx
import React from "react";
import { useParams, Link } from "react-router-dom";
import { projects } from "../data/projects";
import './style-sheet.css';
import gitIcon from '../Components/Assets/github-mark.png';
import lIIcon from '../Components/Assets/LI-In-Bug.png';

export const ProjectDetails = () => {
  const { id } = useParams();
  const project = projects.find((p) => p.id === Number(id));

  if (!project) return <p>Projekt ikke fundet.</p>;

  return (
    <div className="project-details">
      <h2>{project.title}</h2>

      <div className="project-content">
        <img src={project.imageUrl} alt={project.title} />

        <div className="project-text">
          <p>{project.description}</p>
          <p>
            <strong>Kategori:</strong> {project.category}
          </p>
          <p>
            <strong>Operativsystemer:</strong>{" "}
            {Array.isArray(project.operatingSystems)
              ? project.operatingSystems.length === 2
                ? project.operatingSystems.join(" og ")
                : project.operatingSystems.join(", ")
              : project.operatingSystems}
          </p>
          <p>
            <strong>Oprettet:</strong>{" "}
            {new Date(project.createdAt).toLocaleDateString("da-DK")}
          </p>
          <p><strong>Download:</strong></p>
          <div className="download-buttons">
            {project.zipUrlWin && (
              <a href={project.zipUrlWin} className="contact-link" download>
                Download for Windows
              </a>
            )}
          </div>
          <p>
            <strong>VIGTIGT:</strong> Ved at bruge applikationen accepterer du vilkårene og betingelserne samt README-filen i zip-filen.
            <br/><br/><Link to="/vilkaar" className="contact-link">Vilkår og Betingelser</Link>
          </p>
          <div className="social-icons">
            <a href="https://github.com/LSchouG" target="_blank" rel="noopener noreferrer">
              <img src={gitIcon} alt="GitHub" />
            </a>
            <a href="https://www.linkedin.com/in/lars-schou-gregersen-18b477248/" target="_blank" rel="noopener noreferrer">
              <img src={lIIcon} alt="LinkedIn" />
            </a>
          </div>
        </div>
        
      </div>

      <Link to="/Portefølje">
        <button>← Tilbage til Portefølje</button>
      </Link>

    </div>
  );
}